module.exports = __webpack_public_path__ + "static/media/fungoxyl.6baa922e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/mildiu_pepino/curativa/fungoxyl.png
// module id = 2110
// module chunks = 3